<template>
    <div class="login">
        <div class="tmp-block">
            <h2>Вход в кабинет игрока</h2>
            <form action="#" @submit.prevent="submit">
                <text_field v-model="login" placeholder="Никнейм" autocomplete="login"/>
                <text_field v-model="password" placeholder="Пароль на сервере" type="password" autocomplete="password"/>
                <large_button class="submit" type="submit" :disabled="loading">Войти</large_button>
            </form>
            <div class="error-block" v-if="error">{{error}}</div>
            <div class="line"></div>
            <p class="caps">Если привязан ВК</p>
            <secondary_button @click.native="loginVk">Войти через ВКонтакте</secondary_button>
        </div>
    </div>
</template>

<script>
    import text_field from '../elements/text_field.vue'
    import large_button from '../elements/large_button.vue'
    import secondary_button from '../elements/secondary_button.vue'
    import {mapActions, mapMutations} from "vuex";

    export default {
        name: "Login",
        components:{
            text_field,
            large_button,
            secondary_button,
        },
        data: ()=>({
            error: false,
            loading: false,

            login: '',
            password: ''
        }),
        beforeRouteEnter (to, from, next) {
            document.body.classList.add('show-grecaptcha-badge');
            next();
        },
        beforeRouteLeave (to, from, next) {
            document.body.classList.remove('show-grecaptcha-badge');
            next();
        },
        methods: {
            loginVk(){
                this.authVk().then((session)=>{
                    let data = new FormData();
                    for (const key in session) {
                        if(key !== 'user') data.append(`vk[${key}]`, session[key]);
                    }
                    return this.authInVk({data}).then((data)=>{
                        this.$auth.fetch().then(()=>{
                            this.$router.push({
                                name: 'profile'
                            });
                        });
                        this.putNotificationDefault('Успешная авторизация, загрузка данных профиля...');
                    });
                }).catch((err)=>{
                    console.log(err);
                    this.putNotificationErr(err);
                });
            },
            captcha(){
                if(!window.hasOwnProperty('grecaptcha')) return Promise.resolve();
                else {
                    return new Promise((resolve) => {
                        grecaptcha.ready(resolve);
                    }).then(()=>grecaptcha.execute('6Lc6KdwZAAAAAIHIfZwQdu_rYhlRvPyu9pylPR7j', {action: 'submit'}))
                }
            },
            submit(){
                this.startLoading();

                this.loading = true;
                this.error = false;
                const {login, password} = this;


                this.captcha().then((token) =>
                    this.$auth.login({
                        params: {
                            token,
                            login,
                            password: btoa(password)
                        }
                    })
                )
                    .then(() => {
                        this.finishLoading();

                        if (!this.$auth.token()) throw 'Ошибка сервера!';
                        setTimeout(() => this.loading = false, 5000);
                    })
                    .catch(e => {
                        this.finishLoading();

                        this.loading = false;
                        this.error = e;
                    });
            },
            ...mapActions('cabinet', ['authVk','authInVk']),
            ...mapMutations('notifications', ['putNotificationDefault','putNotificationErr']),
            ...mapMutations('loading_progress', ['startLoading', 'finishLoading']),
        }
    }
</script>

<style scoped lang="scss">
    .login{
        max-width: 560px;
        margin: 0 auto;

        .line{
            margin: 24px 0;
        }
        .caps{
            margin-bottom: 16px;
            text-align: center;
        }

        @include tablet{
            //margin: 0;
        }
    }
</style>
